import api from "./api";

class PatientService {
  static getById(memberId) {
    return api.get(`/patient/${memberId}`);
  }
}

export default PatientService;
